import { Link } from 'react-router-dom';

import type { BreadcrumbItem } from '@/features/layout';

import styles from './Breadcrumbs.module.css';

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

function BreadcrumbLabel({
  item,
  isLast,
}: {
  item: BreadcrumbItem;
  isLast: boolean;
}) {
  if (isLast) {
    return <h1 className={styles.breadcrumbCurrent}>{item.label}</h1>;
  }

  if (item.to) {
    return (
      <Link to={item.to} className={styles.breadcrumbLink}>
        {item.label}
      </Link>
    );
  }

  return <span className={styles.breadcrumbText}>{item.label}</span>;
}

function Breadcrumbs({ items }: BreadcrumbsProps) {
  if (items.length === 0) return null;

  return (
    <nav className={styles.breadcrumb} aria-label="Breadcrumb">
      <ol className={styles.breadcrumbList}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.label} className={styles.breadcrumbItem}>
              {index > 0 && (
                <span className={styles.separator} aria-hidden="true">
                  ›
                </span>
              )}
              <BreadcrumbLabel item={item} isLast={isLast} />
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
